export const TRENDY_FILTERS = {
  سنوي: {
    rent_period: {
      eq: 3,
    },
    seo: {
      title: "عقد سنوي",
    },
  },
  شهري: {
    rent_period: {
      eq: 2,
    },
    seo: {
      title: "عقد شهري",
    },
  },

  دفعتين: {
    price_2_payments: {
      gte: "1",
    },
    seo: {
      title: "عقد سنوي دفعتين دفعة كل ستة شهور",
    },
  },
  "4-دفعات": {
    price_4_payments: {
      gte: "1",
    },
    seo: {
      title: "عقد سنوي 4 دفعات دفعة كل 3 شهور",
    },
  },
  شهريا: {
    price_12_payments: {
      gte: "1",
    },
    seo: {
      title: "عقد سنوي دفع شهري 12 دفعة",
    },
  },

  غرفتين: {
    beds: {
      eq: 2,
    },
    seo: {
      title: "غرفتين وصالة",
    },
  },
  "ثلاث-غرف": {
    beds: {
      eq: 3,
    },
    seo: {
      title: "3 ثلاث غرف",
    },
  },
  "أربع-غرف": {
    beds: {
      eq: 4,
    },
    seo: {
      title: "4 أربع غرف",
    },
  },
  "خمس-غرف": {
    beds: {
      eq: 5,
    },
    seo: {
      title: "5 خمس غرف",
    },
  },
  "أكثر-من-5-غرف": {
    beds: {
      gt: 5,
    },
    seo: {
      title: "أكثر من 5 غرف",
    },
  },
  عزاب: {
    family: {
      eq: 0,
    },
  },
  عوائل: {
    family: {
      eq: 1,
    },
  },
  "مدخل-سيارة": {
    car_entrance: {
      eq: 1,
    },
  },
  "دور-أرضي": {
    fl: {
      eq: 0,
    },
  },
  "دور-أول": {
    fl: {
      eq: 1,
    },
  },
  "أقل-من-2-سنة": {
    age: {
      lte: 2,
    },
  },
  جديد: {
    age: {
      lte: 2,
    },
  },
  جديدة: {
    age: {
      lte: 2,
    },
  },
  "أقل-من-5-سنة": {
    age: {
      lte: 5,
    },
    seo: {
      title: "عمر العقار أقل من 5 سنوات",
    },
  },
  "أقل-من-10-سنة": {
    age: {
      lte: 10,
    },
    seo: {
      title: "عمر العقار أقل من 10 سنوات",
    },
  },
  "أقل-من-15-سنة": {
    age: {
      lte: 15,
    },
    seo: {
      title: "عمر العقار أقل من 15 سنة",
    },
  },
  مكيفة: {
    ac: {
      eq: 1,
    },
  },
  مكيف: {
    ac: {
      eq: 1,
    },
  },
  "سطح-خاص": {
    private_roof: {
      eq: 1,
    },
  },
  "في-فيلا": {
    apartment_in_villa: {
      eq: 1,
    },
  },
  مدخلين: {
    two_entrances: {
      eq: 1,
    },
  },
  "مدخل-خاص": {
    special_entrance: {
      eq: 1,
    },
  },

  "درج-صالة": {
    stairs: {
      lte: 1,
    },
  },
  "شقة-واحدة": {
    apts: {
      eq: 1,
    },
  },
  شقتين: {
    apts: {
      eq: 2,
    },
  },
  "٣-شقق": {
    apts: {
      eq: 3,
    },
  },
  "٤-شقق": {
    apts: {
      eq: 4,
    },
  },
  "500-ريال-يومي": {
    price: {
      lte: 500,
    },
    seo: {
      title: " بسعر 500 ريال في اليوم",
    },
  },
  "أقل-من-1.2-مليون": {
    price: {
      lt: 1200000,
    },
  },
  "أقل-من-2-مليون": {
    price: {
      gte: 1200000,
      lt: 2000000,
    },
  },
  "أقل-من-5-مليون": {
    price: {
      gte: 2000000,
      lt: 5000000,
    },
  },
  "فلل-وقصور-فاخرة": {
    price: {
      gte: 5000000,
    },
  },

  "غرفة-سائق": {
    driver: {
      eq: 1,
    },
  },
  "غرفة-خادمة": {
    maid: {
      eq: 1,
    },
  },
  مسبح: {
    pool: {
      eq: 1,
    },
  },
  مؤثثة: {
    furnished: {
      eq: 1,
    },
  },

  "الواجهة-شمال": {
    street_direction: {
      eq: 1,
    },
  },
  "الواجهة-شرق": {
    street_direction: {
      eq: 2,
    },
  },
  "الواجهة-غرب": {
    street_direction: {
      eq: 3,
    },
  },
  "الواجهة-جنوب": {
    street_direction: {
      eq: 4,
    },
  },
  "الواجهة-شمال-شرقي": {
    street_direction: {
      eq: 5,
    },
  },
  "الواجهة-جنوب-شرقي": {
    street_direction: {
      eq: 6,
    },
  },
  "الواجهة-جنوب-غربي": {
    street_direction: {
      eq: 7,
    },
  },
  "الواجهة-شمال-غربي": {
    street_direction: {
      eq: 8,
    },
  },
  "تفتح-على-3-شوارع": {
    street_direction: {
      eq: 9,
    },
  },
  "تفتح-على-4-شوارع": {
    street_direction: {
      eq: 10,
    },
  },
  مطبخ: {
    ketchen: {
      eq: 1,
    },
  },
  "عرض-الشارع-أكثر-من-5-متر": {
    street_width: {
      gte: 5,
    },
  },
  "عرض-الشارع-أكثر-من-10-متر": {
    street_width: {
      gte: 10,
    },
  },
  "عرض-الشارع-أكثر-من-15-متر": {
    street_width: {
      gte: 15,
    },
  },
  "عرض-الشارع-أكثر-من-20-متر": {
    street_width: {
      gte: 20,
    },
  },
  "عرض-الشارع-أكثر-من-30-متر": {
    street_width: {
      gte: 30,
    },
  },
  "عرض-الشارع-أكثر-من-50-متر": {
    street_width: {
      gte: 50,
    },
  },
  قبو: {
    basement: {
      eq: 1,
    },
  },
  "فيلا-مستقلة": {
    villa_type: {
      eq: "standalone",
    },
  },
  دوبلكس: {
    villa_type: {
      eq: "duplex",
    },
  },
  "تاون-هاوس": {
    villa_type: {
      eq: "townhouse",
    },
  },

  "أقل-من-1500-ريال-للمتر": {
    meter_price: {
      lte: 1500,
    },
  },
  "أقل-من-3-آلاف-ريال-للمتر": {
    meter_price: {
      lte: 3000,
    },
  },
  "أقل-من-10-آلاف-ريال-للمتر": {
    meter_price: {
      lte: 10000,
    },
  },
  "أقل-من-20-ألف-ريال-للمتر": {
    meter_price: {
      lte: 20000,
    },
  },
  "أكثر-من-20-ألف-ريال-للمتر": {
    meter_price: {
      gte: 20000,
    },
  },

  "قسم-عوائل": {
    family_section: {
      eq: 1,
    },
    seo: {
      title: "قسم عوائل (قسمين رجالي و نسائي)",
    },
  },

  يومي: {
    rent_period: {
      eq: 1,
    },
  },

  "ملعب-كرة-قدم": {
    fb: {
      eq: 1,
    },
  },
  "ملعب-كرة-طائرة": {
    vb: {
      eq: 1,
    },
  },
  "بيت-شعر": {
    tent: {
      eq: 1,
    },
  },

  ملاهي: {
    playground: {
      eq: 1,
    },
  },
};
export const TRENDY_FILTERS_BASED_ON_CATEGORY = {
  1: {
    دفعتين: 1,
    "4-دفعات": 1,
    سنوي: 1,
    شهري: 1,
    شهريا: 1,
    غرفتين: 1,
    "ثلاث-غرف": 1,
    "أربع-غرف": 1,
    عزاب: 1,
    عوائل: 1,
    "مدخل-سيارة": 1,
    "دور-أرضي": 1,
    "دور-أول": 1,
    جديدة: 1,
    "أقل-من-5-سنة": 1,
    مكيفة: 1,
    "سطح-خاص": 1,
    "في-فيلا": 1,
    مدخلين: 1,
    "مدخل-خاص": 1,
  },
  2: {
    سكني: 1,
    تجاري: 1,
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
    "الواجهة-شمال": 1,
    "الواجهة-شرق": 1,
    "الواجهة-غرب": 1,
    "الواجهة-جنوب": 1,
    "الواجهة-شمال-شرقي": 1,
    "الواجهة-جنوب-شرقي": 1,
    "الواجهة-جنوب-غربي": 1,
    "الواجهة-شمال-غربي": 1,
    "تفتح-على-3-شوارع": 1,
    "تفتح-على-4-شوارع": 1,
    "أقل-من-1500-ريال-للمتر": 1,
    "أقل-من-3-آلاف-ريال-للمتر": 1,
    "أقل-من-10-آلاف-ريال-للمتر": 1,
    "أقل-من-20-ألف-ريال-للمتر": 1,
    "أكثر-من-20-ألف-ريال-للمتر": 1,
  },
  3: {
    "شقة-واحدة": 1,
    شقتين: 1,
    "٣-شقق": 1,
    "٤-شقق": 1,
    "أقل-من-1.2-مليون": 1,
    "أقل-من-2-مليون": 1,
    "أقل-من-5-مليون": 1,
    "فلل-وقصور-فاخرة": 1,
    غرفتين: 1,
    "ثلاث-غرف": 1,
    "أربع-غرف": 1,
    "خمس-غرف": 1,
    "أكثر-من-5-غرف": 1,
    "مدخل-سيارة": 1,
    مسبح: 1,
    مؤثثة: 1,
    جديدة: 1,
    "أقل-من-5-سنة": 1,
    "الواجهة-شمال": 1,
    "الواجهة-شرق": 1,
    "الواجهة-غرب": 1,
    "الواجهة-جنوب": 1,
    "الواجهة-شمال-شرقي": 1,
    "الواجهة-جنوب-شرقي": 1,
    "الواجهة-جنوب-غربي": 1,
    "الواجهة-شمال-غربي": 1,
    "تفتح-على-3-شوارع": 1,
    "تفتح-على-4-شوارع": 1,
    مطبخ: 1,
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
    قبو: 1,
    "فيلا-مستقلة": 1,
    دوبلكس: 1,
    "تاون-هاوس": 1,
  },
  4: {
    دفعتين: 1,
    "4-دفعات": 1,
    شهريا: 1,
    سنوي: 1,
    شهري: 1,
    غرفتين: 1,
    "ثلاث-غرف": 1,
    "أربع-غرف": 1,
    "خمس-غرف": 1,
    "أكثر-من-5-غرف": 1,
    "دور-أرضي": 1,
    "دور-أول": 1,
    "الدور-3": 1,
    "الدور-4": 1,
    "الدور-5-وأكثر": 1,
    "مدخل-سيارة": 1,
    جديد: 1,
    "أقل-من-5-سنة": 1,
    مكيف: 1,
    "في-فيلا": 1,
    مدخلين: 1,
    "مدخل-خاص": 1,
  },
  5: {
    دفعتين: 1,
    "4-دفعات": 1,
    سنوي: 1,
    شهري: 1,
    شهريا: 1,
    غرفتين: 1,
    "ثلاث-غرف": 1,
    "أربع-غرف": 1,
    "خمس-غرف": 1,
    "أكثر-من-5-غرف": 1,
    "مدخل-سيارة": 1,
    مسبح: 1,
    مؤثثة: 1,
    جديدة: 1,
    "أقل-من-5-سنة": 1,
    "الواجهة-شمال": 1,
    "الواجهة-شرق": 1,
    "الواجهة-غرب": 1,
    "الواجهة-جنوب": 1,
    "الواجهة-شمال-شرقي": 1,
    "الواجهة-جنوب-شرقي": 1,
    "الواجهة-جنوب-غربي": 1,
    "الواجهة-شمال-غربي": 1,
    "تفتح-على-3-شوارع": 1,
    "تفتح-على-4-شوارع": 1,
    مطبخ: 1,
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
    قبو: 1,
    مكيفة: 1,
    "فيلا-مستقلة": 1,
    دوبلكس: 1,
    "تاون-هاوس": 1,
  },
  6: {
    غرفتين: 1,
    "ثلاث-غرف": 1,
    "أربع-غرف": 1,
    "خمس-غرف": 1,
    "أكثر-من-5-غرف": 1,
    "مدخل-سيارة": 1,
    "دور-أرضي": 1,
    "دور-أول": 1,
    "الدور-3": 1,
    "الدور-4": 1,
    "الدور-5-وأكثر": 1,
    جديدة: 1,
    "أقل-من-5-سنة": 1,
    "سطح-خاص": 1,
    "في-فيلا": 1,
    مدخلين: 1,
    "مدخل-خاص": 1,
  },
  7: {
    سكني: 1,
    تجاري: 1,
    "شقة-واحدة": 1,
    شقتين: 1,
    "٣-شقق": 1,
    "٤-شقق": 1,
    "المحلات-أقل-من-4": 1,
    "المحلات-أكثر-من-5": 1,
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
    جديدة: 1,
    "أقل-من-5-سنة": 1,
    "الواجهة-شمال": 1,
    "الواجهة-شرق": 1,
    "الواجهة-غرب": 1,
    "الواجهة-جنوب": 1,
    "الواجهة-شمال-شرقي": 1,
    "الواجهة-جنوب-شرقي": 1,
    "الواجهة-جنوب-غربي": 1,
    "الواجهة-شمال-غربي": 1,
    "تفتح-على-3-شوارع": 1,
    "تفتح-على-4-شوارع": 1,
  },
  8: {
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
  },
  9: {
    غرفتين: 1,
    "ثلاث-غرف": 1,
    "أربع-غرف": 1,
    "خمس-غرف": 1,
    "أكثر-من-5-غرف": 1,
    "بيت-شعر": 1,
    مؤثثة: 1,
    جديد: 1,
    "أقل-من-5-سنة": 1,
    "الواجهة-شمال": 1,
    "الواجهة-شرق": 1,
    "الواجهة-غرب": 1,
    "الواجهة-جنوب": 1,
    "الواجهة-شمال-شرقي": 1,
    "الواجهة-جنوب-شرقي": 1,
    "الواجهة-جنوب-غربي": 1,
    "الواجهة-شمال-غربي": 1,
    "تفتح-على-3-شوارع": 1,
    "تفتح-على-4-شوارع": 1,
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
  },
  10: {
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
  },
  11: {
    غرفتين: 1,
    "ثلاث-غرف": 1,
    "أربع-غرف": 1,
    "خمس-غرف": 1,
    "أكثر-من-5-غرف": 1,
    "بيت-شعر": 1,
    مؤثثة: 1,
    جديد: 1,
    "أقل-من-5-سنة": 1,
    "الواجهة-شمال": 1,
    "الواجهة-شرق": 1,
    "الواجهة-غرب": 1,
    "الواجهة-جنوب": 1,
    "الواجهة-شمال-شرقي": 1,
    "الواجهة-جنوب-شرقي": 1,
    "الواجهة-جنوب-غربي": 1,
    "الواجهة-شمال-غربي": 1,
    "تفتح-على-3-شوارع": 1,
    "تفتح-على-4-شوارع": 1,
    مطبخ: 1,
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
  },
  12: {
    "أقل-من-1500-ريال-للمتر": 1,
    "أقل-من-3-آلاف-ريال-للمتر": 1,
    "أقل-من-10-آلاف-ريال-للمتر": 1,
    "أقل-من-20-ألف-ريال-للمتر": 1,
    "أكثر-من-20-ألف-ريال-للمتر": 1,
  },
  13: {
    "قسم-عوائل": 1,
    يومي: 1,
    شهري: 1,
    سنوي: 1,
    "500-ريال-يومي": 1,
    مسبح: 1,
    "ملعب-كرة-قدم": 1,
    "ملعب-كرة-طائرة": 1,
    "بيت-شعر": 1,
    مطبخ: 1,
    ملاهي: 1,
  },
  14: {
    مؤثثة: 1,
    "أقل-من-1500-ريال-للمتر": 1,
    "أقل-من-3-آلاف-ريال-للمتر": 1,
    "أقل-من-10-آلاف-ريال-للمتر": 1,
    "أقل-من-20-ألف-ريال-للمتر": 1,
    "أكثر-من-20-ألف-ريال-للمتر": 1,
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
  },
  15: {
    "أقل-من-1500-ريال-للمتر": 1,
    "أقل-من-3-آلاف-ريال-للمتر": 1,
    "أقل-من-10-آلاف-ريال-للمتر": 1,
    "أقل-من-20-ألف-ريال-للمتر": 1,
    "أكثر-من-20-ألف-ريال-للمتر": 1,
    سكني: 1,
    تجاري: 1,
    "الواجهة-شمال": 1,
    "الواجهة-شرق": 1,
    "الواجهة-غرب": 1,
    "الواجهة-جنوب": 1,
    "الواجهة-شمال-شرقي": 1,
    "الواجهة-جنوب-شرقي": 1,
    "الواجهة-جنوب-غربي": 1,
    "الواجهة-شمال-غربي": 1,
    "تفتح-على-3-شوارع": 1,
    "تفتح-على-4-شوارع": 1,
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
  },
  16: {
    سكني: 1,
    تجاري: 1,
    "شقة-واحدة": 1,
    شقتين: 1,
    "٣-شقق": 1,
    "٤-شقق": 1,
    "المحلات-أقل-من-4": 1,
    "المحلات-أكثر-من-5": 1,
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
    جديدة: 1,
    "أقل-من-5-سنة": 1,
    "الواجهة-شمال": 1,
    "الواجهة-شرق": 1,
    "الواجهة-غرب": 1,
    "الواجهة-جنوب": 1,
    "الواجهة-شمال-شرقي": 1,
    "الواجهة-جنوب-شرقي": 1,
    "الواجهة-جنوب-غربي": 1,
    "الواجهة-شمال-غربي": 1,
    "تفتح-على-3-شوارع": 1,
    "تفتح-على-4-شوارع": 1,
  },
  17: {
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
  },
  18: {
    يومي: 1,
    شهري: 1,
    سنوي: 1,
    "قسم-عوائل": 1,
  },
  19: {
    يومي: 1,
    شهري: 1,
    سنوي: 1,
    مطبخ: 1,
  },
  20: {
    "عرض-الشارع-أكثر-من-5-متر": 1,
    "عرض-الشارع-أكثر-من-10-متر": 1,
    "عرض-الشارع-أكثر-من-15-متر": 1,
    "عرض-الشارع-أكثر-من-20-متر": 1,
    "عرض-الشارع-أكثر-من-30-متر": 1,
    "عرض-الشارع-أكثر-من-50-متر": 1,
  },
  21: {
    يومي: 1,
    شهري: 1,
    سنوي: 1,
    عزاب: 1,
    عوائل: 1,
    "أكثر-من-صالة": 1,
    "أكثر-من-صالتين": 1,
    "أكثر-من-٣-صالات": 1,
    "دور-أرضي": 1,
    "دور-أول": 1,
    "الدور-3": 1,
    "الدور-4": 1,
    "الدور-5-وأكثر": 1,
    جديدة: 1,
    "أقل-من-5-سنة": 1,
    ملحق: 1,
    "مدخل-سيارة": 1,
    مكيفة: 1,
  },
  22: {
    "أكثر-من-صالة": 1,
    "أكثر-من-صالتين": 1,
    "أكثر-من-٣-صالات": 1,
    "دور-أرضي": 1,
    "دور-أول": 1,
    "الدور-3": 1,
    "الدور-4": 1,
    "الدور-5-وأكثر": 1,
    جديد: 1,
    "أقل-من-5-سنة": 1,
    "مدخل-سيارة": 1,
  },
  23: {
    "قسم-عوائل": 1,
    يومي: 1,
    شهري: 1,
    سنوي: 1,
    "500-ريال-يومي": 1,
    مسبح: 1,
    "ملعب-كرة-قدم": 1,
    "ملعب-كرة-طائرة": 1,
    "بيت-شعر": 1,
    مطبخ: 1,
    ملاهي: 1,
  },
};
